import * as React from "react"
import {Toaster, resolveValue} from "react-hot-toast"
import {CircledIcon} from "./icons"

const Toast = () => {
  return (
    <Toaster
      toastOptions={{
        duration: 4000,
      }}
      containerClassName="mt-56"
    >
      {t => (
        <div
          className="mb-10 typo-body-2 text-white dark:bg-[#353F58D9] px-10 py-4 flex flex-row items-center rounded-lg"
          style={{
            background: "rgba(53, 63, 88, 0.85)",
          }}
        >
          {t.type === "error" ? (
            <CircledIcon.Unverify className="w-9 h-9 lg:w-6 lg:h-6 mr-4 flex-shrink-0" />
          ) : (
            <CircledIcon.Verify className="w-9 h-9 lg:w-6 lg:h-6 mr-4 flex-shrink-0" />
          )}
          {resolveValue(t.message, t)}
        </div>
      )}
    </Toaster>
  )
}

export default Toast
